import { Link } from 'react-router-dom';
import VideoPlayer from '../video/VideoPlayer';

export default function Header () {
    return <>
        <div className="container-fluid header p-0 mt-1">
            <div className="row g-0 align-items-center flex-column-reverse flex-md-row">
                <div className="col-md-6 p-5 mt-lg-5">
                    <h1 className="display-5 animated fadeIn mb-4">Find the best Real Estate Investment and a  <span className="text-primary">Perfect Home</span> for Your Family</h1>
                     <p className="animated fadeIn mb-4 pb-2">With {process.env.REACT_APP_COMPANY_NAME} all your real estate needs are covered. Contact us today</p>
                    <Link to="/properties" className="btn btn-primary py-3 px-5 me-3 animated fadeIn">Get Started</Link>
                </div>
                <div className="col-md-6 animated fadeIn">
                    <VideoPlayer />
                </div>
            </div>
        </div>
    </>
}